import React from "react";
// import { Button, Form, FormControl } from "react-bootstrap";
import { Link ,useNavigate } from "react-router-dom";
import { useCreateUserWithEmailAndPassword } from 'react-firebase-hooks/auth';
import auth from '../../firebase.init';
import SocialLogin from "../Login/SocialLogin/SocialLogin";

const Register = () => {

  const [
    createUserWithEmailAndPassword,
    user,
    loading,
    error,
  ] = useCreateUserWithEmailAndPassword(auth);


  const navigate = useNavigate() ; 
  const navigateLogin  = () => {
    navigate('/login')
  }



  const handleRegister = event => {
    event.preventDefault();
    const name = event.target.name.value;
    const email = event.target.email.value;
    const password = event.target.password.value;
    createUserWithEmailAndPassword(email, password)
  }

  
  if (user) {
    return (
      <div>
        <p>Current User: {user.email}</p>
      </div>
    );
  }
  return (
    <div className="container w-50 p-4">
      <h2 className="text-primary text-center mt-2">Please Log in </h2>

      {/* <Form onSubmit={handleRegister}>
        <Form.Group className="mb-3" controlId="formBasicName">
          <Form.Label>User Name </Form.Label>
          <FormControl placeholder="Username" aria-label="Username"/>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control type="email" placeholder="Enter email" />
          <Form.Text className="text-muted">
            We'll never share your email with anyone else.
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formInputPassword">
          <Form.Label>InputPassword</Form.Label>
          <Form.Control type="password" placeholder="Input Password" />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formConfirmPassword">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control type="password" placeholder="Confirm Password" />
        </Form.Group>

        <Button variant="primary" type="submit">
          Submit
        </Button>
      </Form> */}

          {/* custom Form  */}
          <form onSubmit={handleRegister}>

            <input className="w-100 mt-1"  type="text" name="name" id="name" placeholder="Set your user name" />
            <input className="w-100 mt-1"  type="email" name="email" id="email" placeholder="Your Email Address " />

            <input className="w-100 mt-1"  type="password" name="password " id="password" />
            <br />
            <input className="w-100 mt-1" type="submit" value="Register" />

          </form>


      <div>
        {" "}
        Already Registered ?{" "}
        <Link to="/login" className="text-primary pe-auto text-decoration-none" onClick={navigateLogin}>
          Please login !
        </Link>
      </div>

      <SocialLogin></SocialLogin>
    </div>
  );
};

export default Register;
